import { useId, type ReactNode } from 'react'
import { Checkbox } from '@/components/ui/Checkbox'
import { cn } from '@/utils/cn'

interface ToggleFieldProps {
  label: ReactNode
  description?: ReactNode
  checked: boolean
  onCheckedChange: (checked: boolean) => void
  disabled?: boolean
  className?: string
}

/** Checkbox with an inline label and optional help text. */
export function ToggleField({
  label,
  description,
  checked,
  onCheckedChange,
  disabled,
  className,
}: ToggleFieldProps) {
  const id = useId()
  const descId = description ? `${id}-desc` : undefined
  return (
    <div className={cn('flex items-start gap-3', className)}>
      <Checkbox
        id={id}
        checked={checked}
        onCheckedChange={(c) => onCheckedChange(c === true)}
        disabled={disabled}
        aria-describedby={descId}
        className="mt-0.5"
      />
      <div className="min-w-0 flex-1">
        <label htmlFor={id} className="text-sm font-medium text-ink">
          {label}
        </label>
        {description ? (
          <p id={descId} className="mt-0.5 text-xs text-muted">
            {description}
          </p>
        ) : null}
      </div>
    </div>
  )
}
